export const isSmallScreen = () => window.innerWidth < 700;
